import { Trans } from '@lingui/macro';

import { Qrcode } from '../qrcode/qrcode';

import styles from './ticket-qr.module.css';

export const TicketQr = ({ data }: { data: string }) => {
  return (
    <div className={styles.container}>
      <Qrcode data={data} size={180} />
      <p
        style={{
          margin: '14px 0 ',
          color: '#808080',
          fontSize: 14,
          fontWeight: 500,
          textAlign: 'center',
        }}
      >
        <Trans>Покажите QR код проводнику в поезде</Trans>
      </p>

      <hr
        className={styles.divider}
        style={{ marginBottom: 18 }}
        aria-hidden="true"
      />
    </div>
  );
};
